export function getIconType(type, dynamic) {
    /* In case 'campaign' the fallthrough to default is intended if data.dynamic is not truthy */
    // noinspection FallThroughInSwitchStatementJS
    switch (type) {
        case 'campaign':
            if (dynamic) return 'dynamic-campaign';
        default:
            return type;
        case 'text':
            return 'text-compact';
        case 'rssfeed':
            return 'rss-compact';
        case 'streaming':
            return 'streaming-compact';
        case 'widget':
            return 'widget-compact';
        case 'iframe':
            return 'web';
        case 'emptyrectangle':
            return 'empty-rectangle';
        case 'background':
            return 'template';
    }
}

const titles = {
    'text-compact': Lang.langGet('Text'),
    'rss-compact': Lang.langGet('RSS Feed'),
    'streaming-compact': Lang.langGet('Streaming'),
    'web': Lang.langGet('Web'),
    youtube: Lang.langGet('YouTube'),
    countdown: Lang.langGet('Countdown'),
    qrcode: Lang.langGet('QR Code'),
    picture: Lang.langGet('Picture'),
    video: Lang.langGet('Video'),
    pdf: Lang.langGet('PDF'),
    ppt: Lang.langGet('Powerpoint'),
    'empty-rectangle': Lang.langGet('Empty Rectangle'),
    template: Lang.langGet('Template'),
    campaign: Lang.langGet('Campaign'),
    'dynamic-campaign': Lang.langGet('Dynamic Campaign'),
    clock: Lang.langGet('Clock'),
    day: Lang.langGet('Day'),
    weather: Lang.langGet('Weather'),
    layer: Lang.langGet('Layer'),
    esign: Lang.langGet('eSign'),
    'widget-compact': Lang.langGet('Widget'),
}

export function getTitle(iconType) {
    return titles[iconType];
}
